import { useT } from "@/lib/i18n";

export const OpenStatus = ({ status }) => {
  const { t } = useT();
  if (!status?.configured) return null;
  const text = status.open
    ? `${t("openNow")}${status.closes_at ? ` · ${t("until", { t: status.closes_at })}` : ""}`
    : `${t("closed")}${status.next_open_time ? ` · ${t("opens", { day: t(status.next_open_day), time: status.next_open_time })}` : ""}`;
  return (
    <span data-testid="open-status-badge" className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1 border ${status.open ? "text-emerald-700 bg-emerald-50 border-emerald-200" : "text-red-700 bg-red-50 border-red-200"}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${status.open ? "bg-emerald-500 animate-pulse" : "bg-red-500"}`} />
      {text}
    </span>
  );
};
